import { render, staticRenderFns } from "./SidebarSkeleton.vue?vue&type=template&id=5883ba13&scoped=true&"
import script from "./SidebarSkeleton.vue?vue&type=script&lang=js&"
export * from "./SidebarSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./SidebarSkeleton.vue?vue&type=style&index=0&id=5883ba13&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5883ba13",
  null
  
)

export default component.exports